import { cx } from '@mage-ui/styled-system/css';
import {
  horizontalDivider,
  horizontalDividerRoot,
} from '@mage-ui/styled-system/recipes';

export type HorizontalDividerProps = {
  classNames?: {
    divider?: string;
    root?: string;
  };
};

export const HorizontalDivider = ({ classNames }: HorizontalDividerProps) => {
  return (
    <hr
      className={cx(
        classNames?.divider ?? horizontalDivider(),
        classNames?.root ?? horizontalDividerRoot(),
      )}
    />
  );
};
